/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteLocationCommand } from '../../models/delete-location-command';
import { DeleteLocationCommandResult } from '../../models/delete-location-command-result';

export interface ApiLocationDeleteLocationDelete$Params {
      body?: DeleteLocationCommand
}

export function apiLocationDeleteLocationDelete(http: HttpClient, rootUrl: string, params?: ApiLocationDeleteLocationDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteLocationCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationDeleteLocationDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteLocationCommandResult>;
    })
  );
}

apiLocationDeleteLocationDelete.PATH = '/api/Location/DeleteLocation';
